import React from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { SignInButton } from './SignInButton';
import { SignOutButton } from './SignOutButton';

export default function Login() {
    return (
        <>
            <div className="dashed-border">
                <h1 className="font-thin">Login</h1>
            </div>
            <div className="row mt-3">
            <AuthenticatedTemplate>
                <SignOutButton />
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <SignInButton />
            </UnauthenticatedTemplate>
            </div>
        </>
    );
}
